import React from "react";
import { Card, Rate, Avatar, List } from "antd";

export default function FeedBacks({feedbacks}) {
  return (
    <div>
      <Card>
        <div className="download-section">
          <h3>
            <b>Feedbacks</b>
          </h3>
          <div>
            {feedbacks.map((d, i) => {
              return (
                <Card key={i} style={{ marginBottom: "10px" }}>
                  <List
                    itemLayout="horizontal"
                    dataSource={feedbacks} // Assuming feedbacks is an array
                    renderItem={(d, i) => (
                      <List.Item key={i}>
                        <Card style={{ marginBottom: "10px" }}>
                          <List.Item.Meta
                            avatar={
                              <Avatar
                                src="https://zos.alipayobjects.com/rmsportal/ODTLcjxAfvqbxHnVXCYX.png"
                                alt={d.userid.name}
                              />
                            }
                            title={`${d.userid.name} - ${d.userid.emailid}`}
                          />
                          <div>
                            <Rate
                              size="small"
                              disabled
                              defaultValue={d.rating}
                            />
                            <p>{d.feedback}</p>
                          </div>
                        </Card>
                      </List.Item>
                    )}
                  />
                </Card>
              );
            })}
          </div>
        </div>
      </Card>
    </div>
  );
}
